// @ngInject
function Service($q) {

    var nodes = createMenuNodes();

    var service = {};
    service.getNavigationNodes = getNavigationNodes;

    return service;

    function getNavigationNodes() {
        var deferred = $q.defer();

        deferred.resolve(nodes);
        return deferred.promise;
    }


    function createMenuNodes() {
        var nav = { nodes: [] };

        var dashboard = {
            licenseModules: { baseModule: true },
            stateLink: 'main.dashboard',
            label: ['common.dashboard'],
            iconClass: 'fa fa-dashboard',
            nodes: []
        };

        var contacts = {
            name: 'contacts',
            label: ['common.contacts'],
            iconClass: 'fa fa-users',
            licenseModules: { baseModule: true },
            claims: { user: { read: true }, location: { read: true }, company: { read: true }, role: { read: true } },
            nodes: [
                { stateLink: 'contacts.users', label: ['contacts.users'], licenseModules: { baseModule: true }, claims: { user: { read: true } } },
                { stateLink: 'contacts.locations', label: ['contacts.locations'], licenseModules: { baseModule: true }, claims: { location: { read: true } } },
                { stateLink: 'contacts.companies', label: ['contacts.companies'], licenseModules: { baseModule: true }, claims: { company: { read: true } } },
                { stateLink: 'contacts.roles', label: ['contacts.roles'], licenseModules: { baseModule: true }, claims: { role: { read: true } } },
                { stateLink: 'contacts.bulkoperation', label: ['contacts.bulkoperation'], licenseModules: { baseModule: true }, claims: { role: { read: true } } }
            ]
        };

        var product = {
            name: 'product',
            label: ['common.products'],
            iconClass: 'fa fa-cube',
            licenseModules: { productModule: true },
            claims: { article: { read: true }, brand: { read: true }, articlesOrdersImport: { read: true }, mainGroup: { read: true } },
            nodes: [
                { stateLink: 'product.articles', params: {currentPage: 1, pageSize: 20, filter: '', inactive: false, match: true }, label: ['article.articles'], licenseModules: { productModule: true }, claims: { article: { read: true } } },
                //Deprecated #8046: { stateLink: 'product.priceListSearch', label: ['article.pricelist'], licenseModules: { productModule: true }, claims: { pricelist: { read: true } } },
                //Deprecated #10429: { stateLink: 'product.importfileslist', label: ['article.articleimport'], licenseModules: { productModule: true }, claims: { articlesOrdersImport: { read: true } } },
                { stateLink: 'product.productimport', label: ['article.articleimport'], licenseModules: { productModule: true }, claims: { articlesOrdersImport: { read: true } } },
                { stateLink: 'product.maingroups', label: ['article.maingroup'], licenseModules: { productModule: true }, claims: { mainGroup: { read: true } } },
                { stateLink: 'product.brands', label: ['article.brand'], licenseModules: { productModule: true }, claims: { brand: { read: true } } }
            ]
        };

        var budget = {
            licenseModules: { budgetModule: true },
            name: 'budget',
            label: ['common.budget'],
            iconClass: 'fa fa-bar-chart-o',
            nodes: [
                { stateLink: 'budget.budgets', label: ['common.budget'], licenseModules: { budgetModule: true }, claims: { economy: { read: true } } }
            ]
        };


        var order = {
            name: 'order',
            label: ['common.purchasing'],
            iconClass: 'fa fa-clipboard',
            licenseModules: { orderModule: true },
            claims: { order: { read: true }, purchaseOrder: { read: true }, customerInvoice: { read: true } },
            nodes: [
                { stateLink: 'order.ordersearch', label: ['common.order'], licenseModules: { orderModule: true }, claims: { order: { read: true } } },
                { stateLink: 'order.purchaseordersearch', label: ['order.purchaseorder'], licenseModules: { orderModule: true }, claims: { purchaseOrder: { read: true } } },
                { stateLink: 'order.purchaseorderanalysis', label: ['purchaseorderanalysis.purchaseOrderAnalysisNavigationName'], licenseModules: { orderModule: true }, claims: { order: { read: true } } },
                //{ stateLink: 'order.assortmentPlanning', label: ['order.assortmentPlanning'], licenseModules: { orderModule: true }, claims: { order: { read: true } } },
                { stateLink: 'customerinvoice.customerinvoicesearch', label: ['customerinvoice.customerinvoices'], licenseModules: { ecommerceModule: true }, claims: { customerInvoice: { read: true } } },
                {
                    label: ['stock.reports'], licenseModules: { orderModule: true }, claims: { order: { read: true } }, nodes: [
                        { stateLink: 'order.transitReports', label: ['reports.ui.transit'], licenseModules: { orderModule: true }, claims: { order: { read: true } } },
                        { stateLink: 'order.intrastatReports', label: ['flexmonster.intrastat'], licenseModules: { orderModule: true }, claims: { order: { read: true } } }
                    ]
                }
            ]
        };

        var sales = {
            name: 'sales',
            label: ['common.sales'],
            iconClass: 'fa fa-shopping-cart',
            licenseModules: { orderModule: true },
            claims: { order: { read: true }, purchaseOrder: { read: true }, customerInvoice: { read: true } },
            nodes: [
                { stateLink: 'customerorder.customerordersearch', label: ['customerorder.customerorders'], licenseModules: { ecommerceModule: true }, claims: { customerOrder: { read: true } } },
                { stateLink: 'discountManagement.discounts', params: {show: false, filter: '', canc: false, appr: true, comp: false, months: 2, currPage: 1, pageSize: 10 }, label: ['discountManagement.discounts'], licenseModules: { discountManagementModule: true }, claims: { discount: { read: true } } },
                { stateLink: 'resellerorder.resellerordersearch', label: ['resellerorder.resellerorders'], licenseModules: { ecommerceModule: true }, claims: { resellerOrder: { read: true } } },
                { stateLink: 'resellerorder.createfulfillment', label: ['resellerorder.createfulfillment'], licenseModules: { ecommerceModule: true }, claims: { resellerOrder: { read: true } } },
                {
                    label: ['resellerorder.manageFulfillment'], licenseModules: { ecommerceModule: true }, claims: { resellerOrder: { read: true } }, nodes: [
                        { stateLink: 'resellerorder.manageorders', label: ['resellerorder.manageOrderFulfillments'], licenseModules: { ecommerceModule: true }, claims: { resellerOrder: { read: true } } },
                        { stateLink: 'resellerorder.manageproducts', label: ['resellerorder.manageProductFulfillments'], licenseModules: { ecommerceModule: true }, claims: { resellerOrder: { read: true } } }
                    ]
                },
                // { stateLink: 'resellerorder.resellerOrderInvoice', label: ['resellerorder.resellerOrderInvoice'], licenseModules: { ecommerceModule: true }, claims: { resellerOrder: { read: true } } }
            ]
        };

        var stock = {
            name: 'stock',
            label: ['common.stock'],
            iconClass: 'fa fa-cubes',
            licenseModules: { orderModule: true },
            claims: { stock: { read: true }, inventorying: { read: true } },
            nodes: [
                { stateLink: 'stock.articlesearch', label: ['stock.article'], licenseModules: { orderModule: true }, claims: { stock: { read: true } } },
                { stateLink: 'stock.modelinventorysearch', label: ['stock.inventorymodel'], licenseModules: { orderModule: true }, claims: { inventorying: { read: true } } },
                { stateLink: 'stock.scannerinventorying', params: {filter: '', page: 1, pageSize: 20}, label: ['stock.scannerinventorying'], licenseModules: { orderModule: true }, claims: { inventorying: { read: true } } },
                { stateLink: 'stock.stockpickinglist', label: ['stock.stockpickinglist'], licenseModules: { orderModule: true }, claims: { stock: { read: true } } },
                {
                    label: ['stock.reports'], licenseModules: { orderModule: true }, claims: { stock: { read: true }, seepurchasecost: { read: true } }, nodes: [
                        { stateLink: 'stock.stockValueReports', label: ['stock.stockValueReports'], licenseModules: { orderModule: true }, claims: { stock: { read: true }, seepurchasecost: { read: true } } },
                        { stateLink: 'stock.soldStockReports', label: ['stock.soldStockReports'], licenseModules: { orderModule: true }, claims: { stock: { read: true }, seepurchasecost: { read: true } } },
                    ]
                }
            ]
        };

        var stocklogistics = {
            name: 'stocklogistics',
            label: ['common.stocklogistics'],
            iconClass: 'fa fa-truck',
            licenseModules: { logisticsModule: true },
            claims: { stockLogistics: { read: true }, order: { read: true } },
            nodes: [
                { stateLink: 'stock.orderingpointssearch', label: ['stock.orderingpoints'], licenseModules: { logisticsModule: true }, claims: { stockLogistics: { read: true } } },
                // Hidden: Not complete  { stateLink: 'stocklogistics.masshandlingorderingpoints', label: ['Masshantering av ','stock.orderingpoints'], licenseModules: { logisticsModule: true }, claims: { stockLogistics: { read: true } } },
                { stateLink: 'stocklogistics.articletransfer', label: ['stocklogistics.internaltransfer'], licenseModules: { logisticsModule: true }, claims: { order: { read: true } } },
                { stateLink: 'stocklogistics.eshopreplenishment', label: ['stocklogistics.eshopreplenishment'], licenseModules: { logisticsModule: true }, claims: { order: { read: true } } }
            ]
        };

        var analysis = {
            name: 'analysis',
            label: ['common.analysis'],
            iconClass: 'fa fa-pie-chart',
            licenseModules: { analysisModule: true },
            claims: { analysis: { read: true } },
            nodes: [
                //#5140: { stateLink: 'analysis.reports', label: ['analyse.analysis'], licenseModules: { analysisModule: true }, claims: { analysis: { read: true } } },
                { stateLink: 'analysis.userReports', label: ['analyse.userReports'], licenseModules: { analysisModule: true }, claims: { analysis: { read: true } } },
                //#10657: { stateLink: 'sales.salestotal', label: ['salestotal.salestotal'], licenseModules: { ecommerceModule: true }, claims: { analysis: { read: true }, location: { read: true } } },
                { stateLink: 'stock.saleThroughputReports', label: ['stock.saleThroughputReports'], licenseModules: { orderModule: true }, claims: { analysis: { read: true }, seepurchasecost: { read: true } } },
                { stateLink: 'order.afterSalesClaimReports', label: ['order.afterSalesClaimReports'], licenseModules: { analysisModule: true }, claims: { analysis: { read: true } } }
            ]
        };

        var crm = {
            licenseModules: { crmModule: true },
            name: 'crm',
            label: ['common.crm'],
            iconClass: 'fa fa-smile-o',
            nodes: []
        };

        var administration = {
            name: 'product',
            label: ['common.administration'],
            iconClass: 'fa fa-database',
            licenseModules: { productModule: true, economyModule: true, orderModule: true, baseModule: true, deliveryPlanningModule: true },
            claims: {
                article: { read: true }, salesChannel: { read: true }, intrastat: { read: true }, psychologicalPrice: { read: true }, subCategory: { read: true },
                timeStamping: { read: true }, pricelist: { read: true }, economy: { read: true }, currency: { read: true }, paymentTerm: { read: true }, deliveryTerm: { read: true }, shippingMethod: { read: true }, customerGroup: { read: true }, invoiceType: { read: true }, businessArea: { read: true }
            },
            nodes: [
                {
                    label: ['admin.product'], licenseModules: { productModule: true }, claims: { department: { read: true }, subCategory: { read: true }, article: { read: true }, businessArea: { read: true } }, nodes: [
                        { stateLink: 'product.departments', label: ['article.department'], licenseModules: { productModule: true }, claims: { department: { read: true } } },
                        { stateLink: 'product.subcategories', label: ['article.subcategory'], licenseModules: { productModule: true }, claims: { subCategory: { read: true } } },
                        { stateLink: 'base.articletypes', label: ['article.articletypes'], licenseModules: { productModule: true }, claims: { article: { read: true } } },
                        { stateLink: 'product.variants', label: ['article.variants'], licenseModules: { productModule: true }, claims: { article: { read: true } } },
                        { stateLink: 'product.variantgroups', label: ['article.variantgroups'], licenseModules: { productModule: true }, claims: { article: { read: true } } },
                        { stateLink: 'product.businessareas', label: ['role.businessArea'], licenseModules: { productModule: true }, claims: { businessArea: { read: true } } }
                    ]
                },
                {
                    label: ['admin.purchase'], licenseModules: { baseModule: true }, claims: { paymentTerm: { read: true }, shippingMethod: { read: true }, intrastat: { read: true }, deliveryTerm: { read: true }, country: { read: true }, currency: { read: true }, invoiceType: { read: true } }, nodes: [
                        { stateLink: 'base.paymentterms', label: ['role.paymentTerm'], licenseModules: { baseModule: true }, claims: { paymentTerm: { read: true } } },
                        { stateLink: 'base.shippingmethods', label: ['role.shippingMethod'], licenseModules: { baseModule: true }, claims: { shippingMethod: { read: true } } },
                        { stateLink: 'product.intrastats', label: ['article.intrastats'], licenseModules: { productModule: true }, claims: { intrastat: { read: true } } },
                        { stateLink: 'base.deliveryterms', label: ['role.deliveryTerm'], licenseModules: { baseModule: true }, claims: { deliveryTerm: { read: true } } },
                        { stateLink: 'base.countries', label: ['base.countries'], licenseModules: { baseModule: true }, claims: { country: { read: true } } },
                        //#3577: { stateLink: 'base.articlecollections', label: ['articlecollection.articleCollections'], licenseModules: { baseModule: true }, claims: { article: { read: true } } },
                        //#3577: { stateLink: 'base.ordercollections', label: ['articlecollection.orderCollections'], licenseModules: { baseModule: true }, claims: { order: { read: true } } },
                        { stateLink: 'base.currencies', label: ['base.currencies'], licenseModules: { baseModule: true }, claims: { currency: { read: true } } },
                        { stateLink: 'base.ordertypes', label: ['base.ordertypes'], licenseModules: { baseModule: true }, claims: { orderType: { read: true } } },
                        // Hidden: Not complete { stateLink: 'base.deliveryplanningtemplates', label: ['base.deliveryplanningtemplates'], licenseModules: { deliveryPlanningModule: true }, claims: { deliveryPlanningTemplate: { read: true } } },
                        { stateLink: 'base.invoicetypes', label: ['role.invoiceType'], licenseModules: { baseModule: true }, claims: { invoiceType: { read: true } } }
                    ]
                },
                {
                    label: ['admin.price'], licenseModules: { productModule: true }, claims: { salesChannel: { read: true }, pricelist: { read: true }, customerGroup: { read: true } }, nodes: [
                        { stateLink: 'product.saleschannels', label: ['article.saleschannel'], licenseModules: { productModule: true }, claims: { salesChannel: { read: true } } },
                        { stateLink: 'product.pricelists', label: ['article.pricelists'], licenseModules: { productModule: true }, claims: { pricelist: { read: true } } },
                        { stateLink: 'product.pricelisteditor', label: ['article.pricelisteditor'], licenseModules: { productModule: true }, claims: { pricelist: { read: true } } },
                        { stateLink: 'product.psychologicalprices', label: ['article.psychologicalprices'], licenseModules: { productModule: true }, claims: { psychologicalPrice: { read: true } } },
                        { stateLink: 'product.volumediscounts', label: ['role.volumeDiscount'], licenseModules: { productModule: true }, claims: { volumeDiscount: { read: true } } },
                        { stateLink: 'base.customergroups', label: ['role.customerGroup'], licenseModules: { baseModule: true }, claims: { customerGroup: { read: true } } }
                    ]
                },
                { stateLink: 'main.siefileexport', label: ['economy.siefileexport'], licenseModules: { economyModule: true }, claims: { economy: { read: true } } },
                { stateLink: 'base.accounts', label: ['role.account'], licenseModules: { baseModule: true }, claims: { account: { read: true } } },
                { stateLink: 'base.vats', label: ['role.vat'], licenseModules: { baseModule: true }, claims: { vat: { read: true } } },
                { stateLink: 'base.paymenttypes', label: ['role.paymentType'], licenseModules: { baseModule: true }, claims: { paymentType: { read: true } } },
                { stateLink: 'base.returnreasons', label: ['role.returnReason'], licenseModules: { baseModule: true }, claims: { returnReason: { read: true } } },
                { stateLink: 'contacts.timestampingmanagement', label: ['contacts.timestamping'], licenseModules: { baseModule: true }, claims: { timeStamping: { read: true } } }
            ]
        };

        nav.nodes.push(dashboard);
        nav.nodes.push(contacts);
        nav.nodes.push(product);
        nav.nodes.push(budget);
        nav.nodes.push(order);
        nav.nodes.push(sales);
        nav.nodes.push(stock);
        nav.nodes.push(stocklogistics);
        nav.nodes.push(analysis);
        nav.nodes.push(administration);

        return nav;
    }


}

angular
    .module('navigation.api', [])
    .factory('NavigationApiService', Service);
